/**
 * 缓存说明:
 */
import vm from '@/cache/storeTools.js'
import menuApi from '@/components/api/menuApi.js'

var basestate = {
	menuType: 1, //菜单的类型，会影响菜单加载，1:web界面2:api界面
	menuList: [],
	showTopMenu: false, //上菜单是否显示
	showLeftMenu: false, //左侧菜单是否显示
	showSeparationMenuLeft: false,  // 分离左菜单是否显示
	nowMenu: {}, //当前选中的菜单
	webMenuTree: {}, //web菜单树
	appMenuTree: {} ,//app菜单树
	separationMenuLeftData: [],  // 分离菜单左菜单数据
	airportTopMenu:false,//智慧机场,
	bookmark:true,//书签栏是否显示
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getMenu(state) {
			//获取菜单type1是topMenu2是leftMenu
			return state.menuList
		},
		getWebMenuTree(state, getters) {
			if(isempty(state.webMenuTree)) {
				store.commit("getWebMenuTree")
			}
			return state.webMenuTree
		},
		getAppMenuTree(state, getters) {
			if(isempty(state.appMenuTree)) {
				store.commit("getAppMenuTree")
			}
			return state.appMenuTree
		},
		getBookmark(state){
			return state.bookmark
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		exitFullScreen(state){
			// console.log(state.airportTopMenu);
			var flag = state.airportTopMenu
			vm.Vue.set(state, 'airportTopMenu', !flag)
		},
		/**
		 * 获取菜单列表
		 */
		getMenuList(state) {
			menuApi.getMenu("menuright", true, respon => {
				//华普固定菜单
				/*respon = []*/
				store.commit("setMenuList", respon)
			})
		},
		setMenuList(state, menuList) {
			//循环遍历菜单并且生成唯一序号
			var resetMenu = (upsort, next) => {
				if(upsort.length != 0) {
					upsort += "-"
				}
				return next.map((item, index) => {
					item.sort = upsort + index
					item.next = resetMenu(item.sort, item.next)
					if(isempty(item.webpage)) {
						item.webpage = '/singleSvg'
					}
					return item
				})
			}
			vm.Vue.set(state, 'menuList', resetMenu("", menuList))
			// state.menuList = resetMenu("", menuList)
			if(state.menuType == 1) {
				// state.showTopMenu = true
				vm.Vue.set(state, 'showTopMenu', true)
				// state.showLeftMenu = true
				vm.Vue.set(state, 'showLeftMenu', true)
			} else {
				// state.showTopMenu = false
				vm.Vue.set(state, 'showTopMenu', false)
				// state.showLeftMenu = true
				vm.Vue.set(state, 'showLeftMenu', true)
			}
		},
		setSeparationMenuLeftData(state, data) {
			vm.Vue.set(state, 'separationMenuLeftData', data)
			if(data.length <= 0){
				vm.Vue.set(state, 'showSeparationMenuLeft', false)
			}else{
				vm.Vue.set(state, 'showSeparationMenuLeft', true)
			}
		},
		/*是否显示上菜单赋值*/
		setTopMenuEnable(state, value) {
			vm.Vue.set(state, 'showTopMenu', value)
		},
		/*是否显示左侧菜单*/
		setLeftMenuEnable(state, value) {
			vm.Vue.set(state, 'showLeftMenu', value)
		},
		setNowMenu(state, menuItem) {
			vm.Vue.set(state, 'nowMenu', menuItem)
		},
		getWebMenuTree(state) {
			menuApi.findMenuTreeByType("menuright", respon => {
				vm.Vue.set(state, 'webMenuTree', respon)
			})
		},
		getAppMenuTree(state) {
			menuApi.findMenuTreeByType("appright", respon => {
				vm.Vue.set(state, 'appMenuTree', respon)
			})
		},
		updateSvg(state,msg){
			//svg版本变更后动态更新菜单中的svg版本
			function updateItem(item,pathMap){
				if (item.pagePath != undefined) {
					var info = pathMap[item.pagePath]
					if (info != undefined && item.pageFile != undefined) {
						//找到了,修改版本号
						var fileName = item.pageFile.substring(0, item.pageFile.lastIndexOf('.', item.pageFile.lastIndexOf('.') - 1))+'.'+info.nowVersion+'.svg'
						vm.Vue.set(item,'pageFile',fileName)
					}
				}else{
					for (var i = 0, len = item.next.length; i < len; i++) {
						var nItem = item.next[i]
						updateItem(nItem, pathMap)
					}
				}
			}
			//收到新的svg变更消息以后，根据内容递归更新svgtree
			var dataList = JSON.parse(msg)
			var pathMap = {}
			for (var i = 0, len = dataList.length; i < len; i++) {
				var item = dataList[i]
				pathMap[item.path] = item
			}
			for (var i = 0, len = state.menuList.length; i < len; i++) {
				var item = state.menuList[i]
				updateItem(item, pathMap)
			}
			
		},
		setBookmark(state,val){
			vm.Vue.set(state, 'bookmark', val)
		}

	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */